import { getPercentage } from '../../../../utils';

interface Props {
    totalVotes: number;
    votes: number;
}

export const SSPollResultBar = ({ totalVotes, votes }: Props) => {
    const resultStyle = {
        backgroundColor: 'hsl(var(--c-primary))',
        width: `${getPercentage(votes!, totalVotes!)}%`
    };
    const pollAnswerStyle = (Number(votes) || 0) > 0 ? resultStyle : {};

    return (
        <div className="relative h-1 bg-poll-gray rounded-1px mt-2 mb-1 overflow-hidden">
            <div
                className="absolute top-0 left-0 w-0 h-full transition-all ease-out duration-300"
                style={pollAnswerStyle}
                data-testid="PollResultWrapper"
            ></div>
        </div>
    );
};
